import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { General, Catalogo } from "../../interfaces/general";
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { debounceTime } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
	selector: "app-referencias-familiares",
	templateUrl: "./referencias-familiares.component.html",
	styleUrls: ["./referencias-familiares.component.css"],
})
export class ReferenciasFamiliaresComponent implements OnInit {
	extranjeroEs = false
	pais:string
	paises : any
	municipios: any;
	curps: any = [];
	referencias: any = [];
	@Input() referenciasFamiliares: FormGroup;
	@Input() catalogos: General
	@Input() estadosCiviles: Array<Catalogo>
	@Input() parentescos: Array<Catalogo>
	@Input() estados: any
	@Input() esFamiliar:boolean = true
	@Input() curpSolicitante: string
	@Input() CURPSolicitante = ''
	@Input() esConsulta: boolean = false;
	@Input() esEdicion: boolean = false
	@Output() remover = new EventEmitter<object>();
	@Output() agregar = new EventEmitter<any>();
	@Input() listaDeCurps: Array<any>
	@Output() conCurp = new EventEmitter()


	constructor(private serviciosGenerales: ServiciosGeneralesService,
				private snackBar: MatSnackBar) {

	}

	ngOnInit(): void {
		this.escucharCURP()
		this.listarMunicipios(this.referenciasFamiliares.value.Personas_EntidadFederativaID)
		this.referenciasFamiliares.get('Personas_Nombre').disable()
		this.referenciasFamiliares.get('Personas_ApellidoPaterno').disable()
		this.referenciasFamiliares.get('Personas_ApellidoMaterno').disable()
		// this.referenciasFamiliares.get('Personas_Genero').disable()
		this.referenciasFamiliares.get('Personas_EntidadFederativaID').disable()
		this.referenciasFamiliares.get('Personas_MunicipioID').disable()
		console.log(this.referenciasFamiliares.value)
	}


	ngOnChanges(changes) {
		console.log(this.referenciasFamiliares.value)
	}
	escucharCURP() {
		this.referenciasFamiliares.get("Personas_CURP")
			.valueChanges.pipe(debounceTime(1500))
			.subscribe((CURP) => {
				return CURP.length === 18 &&
										this.CURPSolicitante !== CURP &&
										this.listaDeCurps.filter(value => value === CURP).length === 0 &&
										this.curpSolicitante !== CURP
										? this.obtenerdatosCURP(CURP) :
										this.openSnackBar('Esta CURP ya se encuentra en la lista o es la curp del solicitante','Entendido');
			});
	}
	onRightClick(e) {
		return false;
	}
	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
		duration: 2000,
		});
	}

	obtenerdatosCURP(CURP: string) {
		this.cleanForm();
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {
				if(res.Ok) {
					// this.referenciasFamiliares.reset()
					if(res.Data.Country === "MEX") {
						this.mostrarInformacion(res.Data)
						// this.obtenerListaEstadosID()
						this.extranjeroEs = false;
					} else {
						this.pais = res.Data.Country
						this.extranjeroEs = true;
						this.mostrarInformacion(res.Data)
						this.obtenerPaises();
					}
				} else {
					console.log('Snackbar')
				}
		})
	}
	mostrarInformacion(persona) {

		console.log(persona)
		if (persona !== undefined) {
			if(persona.Country === "MEX") {
				this.idEstadoMunicipioCURP(+persona.StateId, persona.CityId)
			}else {
				this.referenciasFamiliares.get('Personas_EntidadFederativaID').setValue(1001);

			}
			this.getFecha(persona.BirthDate)
			this.referenciasFamiliares.get('Personas_Nombre').setValue(persona.Name);
			this.referenciasFamiliares.get('Personas_ApellidoPaterno').setValue(persona.Lastname);
			this.referenciasFamiliares.get('Personas_ApellidoMaterno').setValue(persona.Surname);
			this.referenciasFamiliares.get('Personas_EntidadFederativaID').setValue(+persona.StateId);
			this.referenciasFamiliares.get('Personas_MunicipioID').setValue(+persona.CityId);
			this.referenciasFamiliares.get('Personas_Genero').setValue(persona.Genre);
			this.conCurp.emit()
		}
	}
	getFecha (fecha:string) {
		const datos = fecha.split('/')
		const ano = datos[2]
		const mes = datos[1]
		const dia = datos[0]
		const nuevaFecha = `${ano}-${mes}-${dia}T00:00:00`
		this.referenciasFamiliares.get('Personas_FechaNacimiento').setValue(nuevaFecha)
		const fechaCumpleanos = this.calculateAge(new Date(+ano,+mes,+dia))
		this.referenciasFamiliares.get('Personas_Edad').setValue(fechaCumpleanos)
	}


	calculateAge(birthday) {
		const ageDifMs = Date.now() - birthday.getTime();
		const ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	}
	idEstadoMunicipioCURP (estadoID, MunicipioID) {
		const idEstadoDB = this.estados.filter(estado => +estado.Codigo === +estadoID)
		this.serviciosGenerales.listadoMunicipios(idEstadoDB[0].ID).subscribe((res) => {
			this.municipios = res
			const idMunicipioID = this.municipios.filter(municipio => +municipio.Codigo === +MunicipioID)
			this.referenciasFamiliares.get('Personas_EntidadFederativaID').setValue(idEstadoDB[0].ID);
			this.referenciasFamiliares.get('Personas_MunicipioID').setValue(idMunicipioID[0].ID);
		});
	}
	obtenerPaises(): void {
		this.serviciosGenerales.listadoPaises().subscribe((res) => {
			this.paises = res;
			const pais = this.paises.filter(
				(pais) => pais.ISO_A3 === this.pais
			);
			this.referenciasFamiliares.get("Personas_PaisID").setValue(pais.ID);
		});
	}


	removerReferencia(i) {
		this.remover.emit({posicion:i, tipo: this.esFamiliar})
	}
	agregarReferencia() {
		this.agregar.emit(this.esFamiliar);
	}

// obtenerdatosCURP(CURP: string) {
// 	this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {
// 		this.curps.push(res.Data)
// 				if(res.Data.Country === "MEX") {
// 					this.obtenerListaEstados(res.Data.StateId)
// 					this.mostrarInformacion(this.curps)
// 					this.extranjeroEs = false;
// 				} else {
// 					this.pais = res.Data.Country
// 					this.extranjeroEs = true;
// 					this.mostrarInformacion(this.curps)
// 					this.obtenerPaises();
// 				}
// 	})
// }

// 	obtenerListaEstados (estadoID?) {
// 		console.log(estadoID)
// 		this.serviciosGenerales.listadoEstados().subscribe(res => {
// 			this.estados = res
// 			console.log(this.estados)
// 			const estado = res.find((estado) => +estado.Codigo === +estadoID)
// 			console.log(estado);
// 			this.listarMunicipios(estado.ID)
// 		});
// 	}

// 	obtenerPaises ():void {
// 		this.serviciosGenerales.listadoPaises().subscribe(res => {
// 			this.paises = res
// 			const pais = this.paises.filter(pais => pais.ISO_A3 === this.pais)
// 			this.referenciasFamiliares.controls.ListaReferenciasFamiliares.get('Personas_PaisID').setValue(pais.ID);
// 		});
// 	}

	listarMunicipios(idEstado?:number) {
		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res
		})
	}

// 	mostrarInformacion(curp) {
// 		console.log(curp);
// 		this.referencias = this.referenciasFamiliares.value.ListaReferenciasFamiliares
// 		this.referencias.forEach((element, i) => {
// 			console.log('element', element);
// 			// this.referencias.Personas_Nombre = curp[i].Name
// 			// this.referencias.Personas_ApellidoPaterno = curp[i].Lastname
// 			// this.referencias.Personas_ApellidoMaterno = curp[i].Surname
// 			// this.referencias.Personas_EntidadFederativaID = curp[i].StateId
// 			// this.referencias.Personas_MunicipioID = curp[i].CityId
// 			// this.referencias.Personas_Genero = curp[i].Genre
// 		});
// 		this.referenciasFamiliares.controls['ListaReferenciasFamiliares'] =
// 		this.formBuilder.array(this.referencias.map(i => this.formBuilder.group(i)))
// 	}

// 	actualizarStore() {
// 		this.referenciasFamiliares.valueChanges.pipe(
//       debounceTime(1500)
//     ).subscribe(referencia => {
// 				this.store.dispatch(SolicitudesActions.refFamiliares({referenciasFamiliares: referencia.ListaReferenciasFamiliares}))
// 		})
// 	}

cleanForm(){
	console.log('funciona: ', this.referenciasFamiliares);
	this.referenciasFamiliares.get('SolicitantePersona_ParentescoID').setValue('');
	this.referenciasFamiliares.get('DatosContacto_TelefonoFijo').setValue('');
	this.referenciasFamiliares.get('DatosContacto_TelefonoCelular').setValue('');
	this.referenciasFamiliares.get('Personas_PaisID').setValue('');
	this.referenciasFamiliares.get('Personas_EstadoCivilID').setValue('');
	this.referenciasFamiliares.get('Personas_Genero').setValue('');
	this.referenciasFamiliares.get('Persona_OcupacionID').setValue('');
	this.referenciasFamiliares.get('Personas_Edad').setValue('');
	this.referenciasFamiliares.get('Personas_FechaNacimiento').setValue('');
	this.referenciasFamiliares.get('confirmarCelular').setValue('');
}

 }
// COVE991007HGTRZL04, JUVA941213HGTRLN09, HERM901214HGTRMR02
